import { DataTable } from "@/components/molecules/tables/data-table";
import { Button } from "@/components/ui/button";
import { useDocuments } from "@/features/documents/hooks/use-documents";
import { useTranslation } from "@/features/utils/i18n";
import { FileMagnifyingGlassIcon, GearIcon } from "@phosphor-icons/react";
import { useNavigate, useParams } from "react-router-dom";
import { PageLayout } from "../layout";
import { useDocumentsBulkActions } from "./components/bulk-actions";
import { useDocumentsColumns } from "./components/columns";
import { UploadDocumentDialog } from "./components/upload-dialog";
import { AddWebsiteDialog } from "./components/website-dialog";
import { WebsiteSources } from "./components/website-sources";

export function DocumentsPage() {
  const { t } = useTranslation("documents");
  const columns = useDocumentsColumns();
  const bulkActions = useDocumentsBulkActions();
  const { company: clientId } = useParams<{ company: string }>();
  const { data, isLoading } = useDocuments();
  const navigate = useNavigate();

  const documents = data?.documents || [];

  return (
    <PageLayout
      title={t("title")}
      description={t("description")}
      actions={
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => navigate(`/${clientId}/data/metadata-config`)}
          >
            <GearIcon className="h-4 w-4" weight="fill" />
            {t("configureMetadata")}
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(`/${clientId}/data/ask`)}
          >
            <FileMagnifyingGlassIcon className="h-4 w-4" weight="fill" />
            {t("askRepository")}
          </Button>
          <AddWebsiteDialog />
          <UploadDocumentDialog />
        </div>
      }
    >
      <WebsiteSources />
      <DataTable
        columns={columns}
        data={documents}
        total={data?.total}
        isLoading={isLoading}
        bulkActions={bulkActions}
      />
    </PageLayout>
  );
}
